import {
  Component,
  ElementRef,
  HostListener,
  Renderer2,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { NgbDropdown, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ui-listing',
  templateUrl: './ui-listing.component.html',
  styleUrls: ['./ui-listing.component.scss'],
})
export class UiListingComponent {
  activePanel = 1;

  active = 'place';
  activeInner = 'type-of-meal';

  isSearchBarActive = false;
  @ViewChild('myDrop') myDrop: NgbDropdown;

  constructor(
    private elRef: ElementRef,
    private modalService: NgbModal,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  modalRef: NgbModalRef | null = null;

  viewSearchBar() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 767) {
      this.isSearchBarActive = !this.isSearchBarActive;
    }
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event) {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.isSearchBarActive = false;
    }
  }

  // Toggle View Function
  gridView: boolean = true;

  toggleGridView() {
    this.gridView = true;
  }

  toggleLineView() {
    this.gridView = false;
  }

  // Modal Code
  modalViewActive: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    const windowWidth = window.innerWidth;
    if (windowWidth < 768) {
      this.modalViewActive = true;
    } else {
      this.modalViewActive = false;
      this.closeRestroContentModal();
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (this.myDrop.isOpen()) {
      this.myDrop.close();
    }
  }
  ngOnInit(): void {
    const windowWidth = window.innerWidth;
    if (windowWidth < 768) {
      this.modalViewActive = true;
    } else {
      this.modalViewActive = false;
    }
  }

  openRestroContentModal(restroContent: TemplateRef<any>) {
    if (this.modalViewActive) {
      this.modalRef = this.modalService.open(restroContent, {
        windowClass: 'project-modal restro-details-modal',
        centered: true,
        backdropClass: 'light-backdrop',
      });
    }
  }

  closeRestroContentModal() {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }

  onRestroScroll() {
    const div = this.elementRef.nativeElement.querySelector(
      '.restro-details-wrap'
    );
    this.renderer.addClass(div, 'scroll-active');
    setTimeout(() => {
      this.renderer.removeClass(div, 'scroll-active');
    }, 1500);
  }
}
